import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, take } from 'rxjs';
import { OpenConfirmationModalService } from '@vendasta/galaxy/confirmation-modal';
import { OrdersEditTabService } from './edit-order-tab.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersEditOrderFormValidationService {
  private invalidForms$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private invalidForms$: Observable<boolean> = this.invalidForms$$.asObservable();

  constructor(
    private confirmationModal: OpenConfirmationModalService,
    private tabService: OrdersEditTabService,
  ) {}

  setInvalidForms(invalidForms: boolean): void {
    this.invalidForms$$.next(invalidForms);
  }

  validateFormsForCharging(): Observable<boolean> {
    return this.invalidForms$.pipe(
      take(1),
      map((invalidForms) => {
        if (invalidForms) {
          this.confirmationModal
            .openModal({
              title: 'LIB_ORDERS.SALES_ORDERS.INVALID_ORDER_FORMS_DIALOG.TITLE',
              message: 'LIB_ORDERS.SALES_ORDERS.INVALID_ORDER_FORMS_DIALOG.MESSAGE',
              confirmButtonText: 'LIB_ORDERS.SALES_ORDERS.INVALID_ORDER_FORMS_DIALOG.GO_TO_FORMS',
              cancelButtonText: 'LIB_ORDERS.COMMON.ACTION_LABELS.CLOSE',
              cancelOnEscapeKeyOrBackgroundClick: true,
            })
            .subscribe((goToForms) => {
              if (goToForms) {
                this.tabService.navigateToOrderFormsTab();
              }
            });
          return false;
        }
        return true;
      }),
    );
  }
}
